import React from "react";
import { Link } from "react-router-dom";
const Button = ({ value, path, disabled }) => {
  const buttonClass = disabled
    ? "bg-white border-[#94A3B8] border-[1px] text-[#CFCFD2]"
    : "bg-[#34BD5A] border-none  text-white";
  return (
    <Link to={path}>
      <button
        disabled={disabled}
        className={`w-[100%] flex items-center justify-between p-[16px] mt-[26px] rounded-[12px] cursor-pointer ${buttonClass}`}
      >
        <h3 className={disabled ? "text-[#CFCFD2]" : "text-white"}>{value}</h3>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M16.6666 5L7.49998 14.1667L3.33331 10"
            stroke={disabled ? "#94A3B8" : "white"}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </Link>
  );
};

export default Button;
